import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("agnes_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const listMessages = () => api.get("/messages").then((r) => r.data);
export const createMessage = (data) => api.post("/messages", data).then((r) => r.data);
export const getReactions = (id) => api.get(`/messages/${id}/reactions`).then((r) => r.data);
export const addReaction = (id, emoji) => api.post(`/messages/${id}/react`, { emoji }).then((r) => r.data);
export const getPublicStats = () => api.get("/stats").then((r) => r.data);
export const getConfig = () => api.get("/config").then((r) => r.data);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
